import { useEffect, useState } from "react";
import OtpInput from "react-otp-input";
import { useParams } from "react-router-dom";
import UploadFileModal from "./chat/Body/UploadDocument";
import useAppState from "context/useAppState";
import UploadVendorDocumentModel from "./chat/Body/UploadDocument/UploadVendorDocument";

const Vendor = ({ }: any) => {
    const [params, setParams] = useState({});
    const { setState: setChatBoxState } = useAppState("chatBox");

    useEffect(() => {
        const queryString = window.location.search;

        // Create a new URLSearchParams object
        const urlParams = new URLSearchParams(queryString);

        // Retrieve individual query parameters
        const vendorId = urlParams.get('id');  // The _id from eventVendor collection
        const eventId = urlParams.get('event');
        const categories: any = urlParams.get('category');
        const parsedCategories = JSON.parse(categories)
        // Update the state with the query parameters
        setParams({ vendorId, eventId, rfp_categories: parsedCategories });
        console.log({ vendorId, eventId, rfp_categories: parsedCategories })
    }, []);

    return (
        <>
            <div className="flex items-center gap-x-3 justify-center mt-20">
                <button
                    type="button"
                    className={`text-lg text-white bg-[#1E0AF5] font-interMedium rounded-lg px-8 py-2}`}
                    onClick={() => setChatBoxState({ showUploadFileModal: true })}>
                    Upload File
                </button>
            </div>

            <div className="flex gap-x-6 relative card-anim-fete-description planning-anim-fete-description">
                <UploadVendorDocumentModel dataObj={params} />
            </div>
        </>
    );
}

export default Vendor;
